import * as Color from 'color'
import { LayoutPackUp } from './layout-pack-up.interface'

export class Layout {
    corPrimaria: string
    corSecundaria: string
    corTerciaria: string
    logoNavbarHeader: string

    constructor(layoutPackUp: LayoutPackUp) {
        if (layoutPackUp) {
            this.corPrimaria = layoutPackUp.CorPrincipal
            this.corSecundaria = layoutPackUp.CorSecundaria
            this.corTerciaria = layoutPackUp.CorTerciaria
            this.logoNavbarHeader = layoutPackUp.LogoMenuPath
        }
    }

    isPadrao() {
        return this.equals(LAYOUT_PADRAO)
    }

    isVazio() {
        return (
            this.corPrimaria === null &&
            this.corSecundaria === null &&
            this.corTerciaria === null &&
            this.logoNavbarHeader === null
        )
    }

    possuiLogo() {
        return !!this.logoNavbarHeader
    }

    equals(other: Layout) {
        if (!(other instanceof Layout)) {
            return false
        }

        if (this.isVazio() && other.isVazio()) {
            return true
        }

        if (this.isVazio() || other.isVazio()) {
            return false
        }

        return (
            isSameColor(this.corPrimaria, other.corPrimaria) &&
            isSameColor(this.corSecundaria, other.corSecundaria) &&
            isSameColor(this.corTerciaria, other.corTerciaria) &&
            this.logoNavbarHeader === other.logoNavbarHeader
        )
    }
}

export const LAYOUT_PADRAO = new Layout({
    Id: null,
    LogoMenuPath:        
        'https://cdn.alterdata.com.br/pack/packup/interno/assets/images/logo-topo-w.png',       
    LogoLoginPath: null,
    LogoEmailPath: null,
    LinkEmail: null,
    CorDeFundoEmail: null,
    CorDoTextoEmail: null,
    LogoRodapeEmailPath: null,
    LinkRodapeEmail: null,
    CorDeFundoRodapeEmail: null,
    CorPrincipal: '#c22743',
    CorSecundaria: '#fff',
    CorTerciaria: '#a82339'
})

function isSameColor(colorA: string, colorB: string) {
    return Color(colorA).hex() === Color(colorB).hex()
}



// WEBPACK FOOTER //
// ./src/app/configuracao/shared/layout.ts